module.exports = __webpack_public_path__ + "media/images/icons/mascot/1-918b3e4584f1839cf4d4ad04dfaa6896.png";